import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { normalizeRiskScore } from '../utils/mapUtils';

interface RiskFactor {
    factor: string;
    score: number;
}

interface RiskChartProps {
    data: RiskFactor[];
    minimal?: boolean;
}

const RiskChart: React.FC<RiskChartProps> = ({ data, minimal = false }) => {
    if (!data || data.length === 0) {
        return null;
    }

    // Normalize scores to 100-point scale for consistency
    const chartData = data.map(d => ({
        factor: d.factor,
        score: normalizeRiskScore(d.score)
    }));

    const chartContent = (
        <div className={minimal ? "h-full w-full" : "h-[300px] w-full"}>
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart cx="50%" cy="50%" outerRadius="80%" data={chartData}>
                    <PolarGrid stroke="#333" />
                    <PolarAngleAxis 
                        dataKey="factor" 
                        tick={{ fill: '#CBD5E1', fontSize: 11, fontWeight: 'bold' }}
                    />
                    <PolarRadiusAxis 
                        angle={30} 
                        domain={[0, 100]} 
                        tick={{ fill: '#94A3B8', fontSize: 10 }}
                    />
                    <Radar
                        name="Risk Level"
                        dataKey="score"
                        stroke="#F43F5E"
                        fill="#F43F5E"
                        fillOpacity={0.6}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#1A1A1A',
                            border: '1px solid rgba(255,255,255,0.1)',
                            borderRadius: '8px',
                            color: '#FFF'
                        }}
                    />
                    <Legend />
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );

    if (minimal) return chartContent;

    return (
        <div className="bg-[#1A1A1A] p-6 rounded-xl border border-white/10 shadow-lg hover:border-white/20 transition-all duration-300">
            <h3 className="text-gray-400 text-sm font-medium mb-6 uppercase tracking-wider">Risk Distribution</h3>
            {chartContent}
        </div>
    );
};

export default RiskChart;